import styled from '@emotion/styled';
import { Box } from '~Styles';

export const Wrapper = styled.div`
  position: relative;
  isolation: isolate;
  overflow: hidden;
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: var(--colorBlueGray1200);
  color: var(--colorWhite);
  min-height: calc(100vh - 64px);
`;

/** Copy of the one we have on the website */
export const GradientBlur = styled.div`
  position: absolute;
  inset-inline: 0;
  top: -10rem;
  z-index: -10;
  transform: translateZ(0);
  overflow: hidden;
  filter: blur(64px);

  @media (min-width: 640px) {
    top: -20rem;
  }

  &::before {
    content: '';
    position: relative;
    left: calc(50% + 11rem);
    aspect-ratio: 1155 / 678;
    width: 36.125rem;
    transform: translateX(-50%) rotate(30deg);
    background: linear-gradient(to top right, #ff80b5, #9089fc);
    opacity: 0.3;
    clip-path: polygon(
      74.1% 44.1%,
      100% 61.6%,
      97.5% 26.9%,
      85.5% 0.1%,
      80.7% 2%,
      72.5% 32.5%,
      60.2% 62.4%,
      52.4% 68.1%,
      47.5% 58.3%,
      45.2% 34.5%,
      27.5% 76.7%,
      0.1% 64.9%,
      17.9% 100%,
      27.6% 76.8%,
      76.1% 97.7%,
      74.1% 44.1%
    );
    display: block;

    @media (min-width: 640px) {
      left: calc(50% + 30rem);
      width: 72.1875rem;
    }
  }
`;

export const ScrollWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
  flex: 1;
  margin: 4px auto auto auto;
  padding: 20px 40px;
  box-sizing: border-box;
`;

export const LogoContainer = styled.div`
  width: 48px;
  height: 48px;
`;

export const Logo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  filter: invert(1);
`;

export const ModesWrapper = styled(Box)`
  flex: 1;
  overflow-y: auto;
  padding-bottom: 20px;
  max-width: 600px;
  min-width: 600px;

  position: relative;

  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }

  mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) calc(100% - 20px),
    rgba(0, 0, 0, 0) 100%
  );
  -webkit-mask-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 1) calc(100% - 20px),
    rgba(0, 0, 0, 0) 100%
  );

  background-image: linear-gradient(
    to bottom,
    transparent calc(100% - 20px),
    var(--colorBlueGray1200) 100%
  );
`;

export const NoLicensesWrapper = styled(Box)`
  max-width: 520px;
`;
